<div class="mx-6 flex flex-col">
  <div>
    Port options enable you to specify individual ports or port ranges for scanning to identify and discover hosts. Use Custom Port Configuration to
    adjust the default service ports included in the scan.
  </div>
  <microsec-form-builder #fb [isPage]="true" [fields]="fields" [shouldShowActionButtons]="false" />
</div>

<ng-template #customPortFields>
  @if (form && form.form && customPortPairArray) {
    <div class="col-span-12 grid grid-cols-12 gap-2 justify-start" [formGroup]="form.form">
      @for (control of customPortPairArray.controls; track $index) {
        <div class="col-span-6 md:col-span-4 lg:col-span-3">
          <div class="items-baseline grid grid-cols-12">
            <label class="col-span-4">{{ control.get(IDS_FORM_PARAMS.SERVICE)?.value | uppercase }}</label>
            <input
              pInputText
              [name]="IDS_FORM_PARAMS.SERVICE"
              [formControl]="$any(control.get(IDS_FORM_PARAMS.SERVICE))"
              [value]="control.get(IDS_FORM_PARAMS.SERVICE)?.value"
              [hidden]="true" />
            <p-inputNumber
              class="mt-3 col-span-8"
              [name]="IDS_FORM_PARAMS.PORT"
              [formControl]="$any(control.get(IDS_FORM_PARAMS.PORT))"
              id="port"
              [useGrouping]="false"
              [min]="1"
              >{{ control.get(IDS_FORM_PARAMS.PORT)?.value }}</p-inputNumber
            >
          </div>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #customPortLabel>
  @if (form) {
    <div class="flex flex-row items-center gap-3 text-lg font-bold mt-3" (click)="handleCustomPortLabelToggle()">
      <label class="cursor-pointer font-bold">Custom Port Configurations</label>
      <i [ngClass]="['pi', 'font-bold', 'cursor-pointer', showConfig ? 'pi-chevron-down' : 'pi-chevron-right']"></i>
    </div>
  }
</ng-template>
